import React from "react"
import { withSearchResultsCard } from "./withSearchResultsCard"
import { Card } from "../../Product/Card/Card"

export const SearchResultsCard = withSearchResultsCard(
  ({ item, collection, livePrice, isPriceLoaded }): JSX.Element => {
    return <Card item={item} collection={collection} isSlider={true} livePrice={livePrice} isPriceLoaded={isPriceLoaded} />
  }
)
